<template>
  <div class="login-page-content">
    <saffron-link v-slot="{ navigate }" :to="{ name: 'index' }">
      <icon-text
        class="back-link c-alt relative z-level-2"
        icon="chevron-inline-start"
        @click="navigate"
        >{{ translateTitleCase("justopp.userLogin.backHome") }}</icon-text
      >
    </saffron-link>
<!--  :login-redirect="getLoginRedirect" -->
    <login
      ref="loginComponent"
      class="main-login-component"

      style="max-width: 100%">
      <template #footer-links>
        <div class="footer-links">
          <div class="login-footer-links-inner flex flex-between">
            <div class="link-wrap">
              <a class="cursor-pointer" @click.prevent="startResetPasswordFlow">{{
                translateUcFirst("justopp.userLogin.resetPasswordCta")
              }}</a>
            </div>
            <div class="link-wrap">
              <saffron-link :to="{ name: 'index' }" class="">{{
                translateUcFirst("core.backHome")
              }}</saffron-link>
            </div>
          </div>
          <div class="register-cta margin-l-top">
            <saffron-link
              class="needs-exact-active"
              :to="{
                name: 'user-register',
                query: { redirectUrl: queryRedirect },
              }">
              <span>{{ translateUcFirst("justopp.userLogin.createAccountCta") }}</span>
            </saffron-link>
          </div>
        </div>
      </template>
    </login>

    <modal
      ref="resetPasswordModal"
      :show="false"
      :show-footer="false"
      title="core.resetPassword.resetPasswordTitle">
      <template #default>
        <password-resetter
          ref="resetPasswordComponent"
          @finished="handlePasswordReset"></password-resetter>
      </template>
    </modal>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import Login from "@/client/views/Login.vue";
import FormButton from "@/client/components/base/frameworks/we/form/FormButton";
import PasswordResetter from "@/client/applications/justopp/components/user/PasswordResetter";
export default {
  components: {
    FormButton,
    Login,
    PasswordResetter,
  },
  layout: {
    component: "sidecut",
    params: {
      backgroundImage: "core/images/sidecut/bg3.jpg",
    }
  },
  middleware: {},
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.userLogin.browserTitle",
  data() {
    return {
      resetStep: 1,
      isResetPasswordFormValid: false,
    };
  },
  computed: {
    modalButtonText() {
      if (this.resetStep == 1) {
        return "justopp.userLogin.resetPasswordStep1Cta";
      } else {
        return "justopp.userLogin.resetPasswordStep2Cta";
      }
    },
    queryRedirect() {
      if (
        this.$router.currentRoute.value.query &&
        this.$router.currentRoute.value.query.redirectUrl
      ) {
        return this.$router.currentRoute.value.query.redirectUrl;
      } else {
        return "/";
      }
    },
  },
  watch: {},
  mounted() {},
  methods: {
    startResetPasswordFlow() {
      this.$refs.resetPasswordModal.open();
      //this.$nextTick(() => this.$refs.resetPasswordComponent.reset());
    },

    handlePasswordReset(eventData) {
      //set email password
      this.$refs.loginComponent.setCredentials({
        email: eventData.email,
        password: eventData.password,
      });
      this.$refs.resetPasswordModal.close();

      this.$refs.loginComponent.loginByState();
      // submit
    },

    getLoginRedirect() {
      let profile = this.$store.getters["user/profile"];

      // should never happen, but lets be safe anyway
      if (!profile) {
        return { path: "/" };
      }

      // we got a redirect in the query
      if (
        this.$router.currentRoute.value.query &&
        this.$router.currentRoute.value.query.redirect
      ) {
        return { name: this.$router.currentRoute.value.query.redirect };
      }

      if (
        this.$router.currentRoute.value.query &&
        this.$router.currentRoute.value.query.redirectUrl
      ) {
        console.log("redirect with loginRedirect");
        return { path: this.$router.currentRoute.value.query.redirectUrl };
      }

      if (profile.Vendor) {
        return {
          name: "company-vendorId-dashboard",
          params: { vendorId: profile.Vendor.id },
        };
      }

      return { path: "/" };
    },
  },
};
</script>

<style lang="scss" scoped>
.back-link {
  position: absolute;
  top: var(--margin-xl);
  inset-inline-start: var(--margin-xl);
}

.main-login-component {
  @media (max-width: 767px) {
    margin-top: var(--margin-2xl);
  }
}
</style>
